import React, { useEffect } from "react";
import { Autocomplete, Box, Button, CircularProgress, Grid, Modal, Paper, Toolbar } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import CommonForm from "../../utils/components/commonForm";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";
import moment from "moment";
import Backdrop from "@mui/material/Backdrop";
import axios from "axios";
import { ContactlessOutlined } from "@mui/icons-material";

const codes = { 
  PUNJAB:"PB", "UTTAR PRADESH":"UP", "HIMANCHAL PRADESH":"HP",
  GUJARAT:"GJ", CHHATISGRAH:"CG", JHARKHAND:"JH",
  RAJASTHAN:"RJ", HARYANA:"HR", DELHI:"DL", "MADHYA PRADESH":"MP",
};

const EditForms = () => {
  const [inputStates, setInputStates] = React.useState({});
  const [inputFields, setInputFields]= React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { reportID, templateID} = useParams();
  const [totalReportCount, setTotalReportCount] = React.useState(0);
  const [templateData, setTemplateData] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };
  const [stateList, setStateList] = React.useState([]);
  useEffect(() => {
    if(templateData?.branchId)
      axiosWithToken
        .get(`${BASE_URL}branch/${templateData?.branchId}`)
        .then(r => setStateList((r.data ?? []).map(s => ({ ...s, shortCode: codes[s.name] }))))
        .catch(console.error);
  }, [templateData?.branchId]);

  const submitReport = async () => {
  
    try {
      const formConfigJson = JSON.stringify(inputStates);

       const b = stateList.find(s => s.id == templateData?.branchId);
    // const n = templateData?.name ?? "";
    // const sec = n.match(/section[-\s]*(\d+)/i)?.[1];
    // const frm = n.match(/form(?:\s*no\.?\s*|[-\s]*)?(\d+)/i)?.[1];
    // const mid = sec ? `/S${sec}` : frm ? "" : "";
    // const res =  `VSS/${b.shortCode}${mid}/${(totalReportCount + 1).toString().padStart(3, "0")}`;

      if (formConfigJson) {
        const reportData =
          reportID < 1
            ? {
                templateId: templateID,
                templateValues: formConfigJson,
                reportNo: `VSS/${b.shortCode}${(() => { const m = templateData?.name; const s = m?.match(/section[-\s]*(\d+)/i); return s ? '/S' + s[1] : (m?.match(/form(?:\s*no\.?\s*|[-\s]*)?(\d+)/i)?.[1] ? '' + "" : ''); })()}/${(totalReportCount + 1).toString().padStart(3, '0')}`,
                // qrCodeNo: reportDetails?.qrCodeNo,
              }
            : {
                templateValues: formConfigJson,
                approvedBy: null,
                // qrCodeNo: reportDetails?.qrCodeNo,
              };

        const reportEndpoint =
          reportID < 1
            ? BASE_URL + "reportValues"
            : BASE_URL + `reportValues/${reportID}`;

        const reportResponse = await (reportID < 1
          ? axiosWithToken.post(reportEndpoint, reportData)
          : axiosWithToken.patch(reportEndpoint, reportData));

        toast(
          reportResponse.status === 200
            ? "Report created/updated successfully!"
            : "Failed to create/update Report."
        );
        if (reportResponse.status === 200) {
          setTimeout(refresh, 500);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    }

  };

  const fetchformReport = async (id) => {
    setLoading(true);
    try {
      const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
      const data = res.data[0];
  
      if (!data || !data.templateValues) {
        console.log("Template data not found or invalid");
        return;
      }
  
      const dataObject = data.templateValues && JSON.parse(data.templateValues);

  const newDataObject = { ...dataObject };
  // delete newDataObject.reportDate;
  setInputStates(newDataObject);
    } catch (error) {
      console.error("Failed to fetch template: ", error);
    } finally {
      setLoading(false);
    }
  };
  

  const fetchTemplate = (id) => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `templates/${id}`)
        .then((res) => {
          let data = res.data[0];
          setTemplateData(data)
          axios.get(data?.url).then((respose) => {
            setInputFields(respose.data);
          });

        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  const fetchAddress = (id) => {
    try {
      let SQLQuery={"query":`SELECT a.address, c.occupierName FROM addresses a left JOIN clients c ON SUBSTRING_INDEX(c.address, ',', 1) = a.id WHERE c.id = ${id}`}
      setLoading(true);
      axiosWithToken
        .post(BASE_URL + `dynamic`,SQLQuery)
        .then((res) => {
          let data = res.data[0];
          setInputStates(prevState => ({
            ...prevState,
            addressFactory: data?.address,
            Occupier: data?.occupierName  
          }));
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const getTotalCountOfReports = () => {


    let SQLQuery={
      "query":`SELECT COUNT(*) AS reportValues_count FROM reportValues where templateId= ${templateID}`
    }

    axiosWithToken
      .post(BASE_URL + `dynamic`,SQLQuery)
      .then((res) => {
        setTotalReportCount(res.data?.[0]?.reportValues_count)
      })
      .catch((err) => {
        toast.error("Something Went Wrong!")
      });
  };



  useEffect(()=>{
   if(templateID) getTotalCountOfReports()
  },[templateID])

useEffect(()=>{
 if(inputStates?.factoryId) fetchAddress(inputStates?.factoryId)
},[inputStates?.factoryId])

  useEffect(() => {
    if (templateID > 0) {
      fetchTemplate(templateID);
    }
    if (reportID > 0) {
      fetchformReport(reportID);
    } 
  }, [reportID, templateID]);

  return (
    <>
      <Paper sx={{ mt: 2, p: 4 }}>
        <CommonForm
          inputStates={inputStates}
          updateInputObject={updateInputObject}
          inputFields={inputFields}
          isTemplateForm={true}
        />

        <Toolbar
          style={{
            padding: "0px",
            overflow: "auto",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              submitReport();
            }}
          >
            {reportID > 0 ? "Update" : "Save"}
          </Button>
        </Toolbar>
        <Modal
        open={loading}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box
          style={{
            width: "100%",
            height: "100vh",
            bgcolor: "background.paper",
            border: "2px solid cadetblue",
            padding: "30px",
            textAlign: "center",
            display: "grid",
            placeItems: "center",
          }}
        >
          <CircularProgress color="secondary" size={200} />
        </Box>
      </Modal>
      </Paper>
    </>
  );
};

export default EditForms;
